import {computed} from "mobx";
import {CompetitorPageMetaDataModel} from "../../../models/competitor-page.meta-data.model";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";
import {FaqPageSchemaModel} from "../../../../../core/models/schema/faq-page-schema-model";

export class CompetitorIndexPageRouteMetaDataModel extends CompetitorPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITOR.main)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITOR.main)
    }

    return description
  }

  get staticTitle() {
    return this.titleFormatTerm(this.websiteTerms.COMPETITOR_HOME_TITLE_TEMPLATE)
  }

  get staticDescription() {
    const description = this.websiteTerms.COMPETITOR_HOME_DESCRIPTION_TEMPLATE.format({
      "LIVESCORE_MAIN_KEYWORD": this.websiteTerms.LIVESCORE_MAIN_KEYWORD
    });

    return this.descriptionFormatTerm(description);
  }

  get dataSchemaFAQ(): FaqPageSchemaModel {
    return this.websiteModuleState.appState.appFaqDisplayModel?.hasElements ? this.schemaManager.createFAQPage(this.websiteModuleState.appState.appFaqDisplayModel?.elements) : null;
  }
}